<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="车号">
              <a-input v-model.trim="queryParam.vehicleNo" placeholder="请输入车号" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="驾驶员">
              <a-input v-model.trim="queryParam.driverName" placeholder="请输入驾驶员姓名" />
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="企业名称">
                <a-input v-model.trim="queryParam.companyName" placeholder="请输入所属企业名称" />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => {queryParam = {}}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleSave()">新增</a-button>
    </div>
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1600 }"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
      >
      <template slot="footer">
      <div>
          <span style="margin-left:0px; font-size:14px;font-weight: 500;color: red">
            备注：新增、修改时，可用输入的车号或手机号带出驾驶员;使用驾驶员姓名查询，可带出下拉手机号，用于下拉选择带出驾驶员
          </span>
      </div>
     </template>

      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
        <span class="blacktr" v-if="blackListOpen && $store.getters.blackList['1'] && $store.getters.blackList['1'][record.id]">
        </span>
      </span>

      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-if="blackListOpen">
              <a v-if="blackListOpen && (!$store.getters.blackList['1'] || !$store.getters.blackList['1'][record.id])" @click="handleBlack(record)">拉黑</a>
            <span v-else>已黑</span></a-menu-item>
            <a-menu-item>
              <a @click="handleDel(record)">删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>
    <a-modal title="操作" style="top: 10px;" :width="800" v-model="visible" @ok="handleOk" :confirmLoading="confirmLoading">
      <a-form class="ant-advanced-search-form" :form="form">
        <a-form-item
          label="车号"
          validateStatus="success"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-input
            placeholder="车号"
            v-model="mdl.vehicleNo"
            @input="changeVehicleNo"
            v-decorator="['vehicleNo', { initialValue: mdl.vehicleNo, rules: [{ required: true, message: '请输入车号'}]}]"
          />
        </a-form-item>

        <a-form-item
          label="手机号" class="ant-form-item-required"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-auto-complete
            :dataSource="phoneSelect"
            style="max-width: 160px"
            placeholder=""
            :filterOption="filterOption"
            @change="(value) => changePhone(value)"  />
        </a-form-item>
        <a-form-item
          label="车辆注册日期"
          validateStatus="success"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-date-picker
            v-model="mdl.registTime"
          ></a-date-picker>
        </a-form-item>
        <a-form-item
          label="行驶证有效期"
          validateStatus="success"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-date-picker
            v-model="mdl.drivingIndate"
          ></a-date-picker>
        </a-form-item>
        <a-form-item
          label="运输证有效期"
          validateStatus="success"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-date-picker
            v-model="mdl.transportIndate"
          ></a-date-picker>
        </a-form-item>
        <a-form-item
          label="资质类别"
          validateStatus="success"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-input
            placeholder="请输入资质类别"
            v-model="mdl.intelligenceType"
            v-decorator="['intelligenceType', { initialValue: mdl.intelligenceType, rules: [{ required: false, message: '请输入车号'}]}]"
          />
        </a-form-item>

        <a-form-item
          label="驾驶员"
          validateStatus="warning"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-select
            :filterOption="filterOption"
            v-model="mdl.driverId" :disabled="true"
            placeholder="请选择驾驶员"
            :label-col=" { span: 6 }"
            :wrapper-col=" { span: 12 }"
          >
            <a-select-option
              v-for="(item, index) in driverSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="驾驶员姓名仅查询"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 4 }"
        >
          <a-input
            placeholder="驾驶员姓名"
            v-model="mdl.driverNameParam"
            @input="changeDriverNameParam"
          />
        </a-form-item>

        <a-form-item
          label="物流公司"
          validateStatus="warning"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-select
            :filterOption="filterOption"
            v-model="mdl.corpLogisticsId"
            placeholder="请选择物流公司"
            :label-col=" { span: 6 }"
            :wrapper-col=" { span: 12 }"
          >
            <a-select-option
              v-for="(item, index) in corpLogisticsSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="车型"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-select
            @change="changeVehicleType"
            :filterOption="filterOption"
            placeholder="请选择车型"
            :label-col=" { span: 6 }"
            :wrapper-col=" { span: 12 }"
            v-decorator="['vehicleTypeId', { initialValue: mdl.vehicleTypeId, rules: [{ required: true, message: '请输入车型'}]}]"
          >
            <a-select-option
              v-for="(item, index) in corpVehicleTypeSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="皮重"
          validateStatus="success"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-input-number
            placeholder=""
            v-model="mdl.tare"
            type="number"
            :min="0"
            v-decorator="['tare', { initialValue: mdl.tare, rules: [{ required: false, message: '请输入数字类型'}]}]"
          />
        </a-form-item>
        <a-form-item
          label="皮重时间"
          validateStatus="success"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-date-picker v-model="mdl.tareTime"></a-date-picker>
        </a-form-item>
        <a-form-item
          label="荷载重量(吨）"
          validateStatus="success"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-input-number
            placeholder=""
            v-model="mdl.loads"
            type="number"
            :min="0"
            v-decorator="['loads', { initialValue: mdl.loads, rules: [{ required: true, message: '请输入荷载重量'}]}]"
          />
        </a-form-item>
        <a-form-item
          label="最大预约量"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-input-number
            placeholder=""
            v-model="mdl.maxAppoint"
            :min="0"
            type="number"
            v-decorator="['maxAppoint', { initialValue: mdl.maxAppoint, rules: [{ required: true, message: '请输入数字'}]}]"
          />
        </a-form-item>
        <a-form-item
          label="最小预约量"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-input-number
            placeholder=""
            v-model="mdl.minAppoint"
            type="number"
            :min="0"
            v-decorator="['minAppoint', { initialValue: mdl.minAppoint, rules: [{ required: true, message: '请输入数字'}]}]"
          />
        </a-form-item>
        <a-form-item
          label="是否厂车"
          validateStatus="warning"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-select
            v-model="mdl.factoryCare"
            v-decorator="['factoryCare', { initialValue: mdl.factoryCare, rules: [{ required: false, message: '请选择是否免审'}]}]"
          >
            <a-select-option value="1">是</a-select-option>
            <a-select-option value="0">否</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="是否启用"
          validateStatus="warning"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-select
            v-model="mdl.used"
            v-decorator="['used', { initialValue: mdl.used, rules: [{ required: true, message: '请选择是否启用'}]}]"
          >
            <a-select-option value="1">是</a-select-option>
            <a-select-option value="0">否</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item
          label="承运业务类型"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-select
            :filterOption="filterOption"
            v-model="mdl.businessTypeId"
            placeholder="请选择业务类型"
            :label-col=" { span: 6 }"
            :wrapper-col=" { span: 12 }"
          >
            <a-select-option
              v-for="(item, index) in bizList"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <!--<a-form-item
          label="随车卡id"
          validateStatus="success"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-input
            placeholder="随车卡id"
            v-model="mdl.cardId"
            v-decorator="['cardId', { initialValue: mdl.cardId, rules: [{ required: false, message: '请输入随车卡id'}]}]"
          />
        </a-form-item>-->
        <a-form-item
          label="行驶证号"
          validateStatus="success"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-input
            placeholder="行驶证号"
            v-model="mdl.drivingNo"
            v-decorator="['drivingNo', { initialValue: mdl.drivingNo, rules: [{ required: false, message: '请输入车号'}]}]"
          />
        </a-form-item>
        <a-form-item
          label="运输证号"
          validateStatus="success"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-input
            placeholder="运输证号"
            v-model="mdl.transportNo"
            v-decorator="['transportNo', { initialValue: mdl.transportNo, rules: [{ required: false, message: '请输入车号'}]}]"
          />
        </a-form-item>
        <a-form-item
          label="使用企业"
          validateStatus="warning"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-select
            :filterOption="filterOption"
            v-model="mdl.corpCompanyId"
            placeholder="请选择使用企业"
            :label-col=" { span: 6 }"
            :wrapper-col=" { span: 12 }"
          >
            <a-select-option
              v-for="(item, index) in corpCompanySelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="客户"
          validateStatus="warning"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-select
            :filterOption="filterOption"
            v-model="mdl.corpBusinessId"
            placeholder="请选择客户"
            :label-col=" { span: 6 }"
            :wrapper-col=" { span: 12 }"
          >
            <a-select-option
              v-for="(item, index) in corpBusinessSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="供应商"
          validateStatus="warning"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >
          <a-select
            :filterOption="filterOption"
            v-model="mdl.corpSupplierId"
            placeholder="请选择供应商"
            :label-col=" { span: 6 }"
            :wrapper-col=" { span: 12 }"
          >
            <a-select-option
              v-for="(item, index) in corpSupplierSelect"
              :key="index"
              :value="item.id"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-divider />
      </a-form>
    </a-modal>

    <a-modal title="拉黑" :width="640" v-model="blackModel" @ok="handleBlackOk" :confirmLoading="confirmLoading">
      <a-form :form="form">
        <a-form-item label="车号" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input disabled placeholder="企业名" v-model="black.name" id="role_name" />
        </a-form-item>

        <a-form-item label="类型" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-select disabled v-model="black.type" placeholder="请选择">
            <a-select-option
              v-for="(item, index) in typeSelect"
              :key="index"
              :value="item.value"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="拉黑原因" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-textarea
            :rows="1"
            v-model="black.remark"
            placeholder="..."
            id="describe"
            v-decorator="['remark',
            { initialValue: black.remark, rules: [{ required: true, message: '请输入拉黑原因'}]}]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import { STable } from '@/components'
import { vehiclePage, vehicleSave, vehicleUpdate, vehicleDelete } from '@/api/basic'
import { corpLogisticsList, getCorpSupplierList, corpCompanyList, corpBusinessList, driverList ,vehicleTypeList,queryDriverInfo} from '@/api/basic'
import { blackListSave } from '@/api/basic'
import { formatDate } from '@/utils/date'
import moment from 'moment'
import config from '@/config/defaultSettings'

export default {
  name: 'VehicleList',
  components: {
    STable
  },
  data() {
    return {
      phoneSelect:[],
      phoneValue:'',
      pageSizeOptionsList:['10'],
      description:
        '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',
      visible: false,
      confirmLoading: false,
      blackModel: false,
      form: this.$form.createForm(this),
      mdl: {},
      black: {},
      blackListOpen: config.blackListOpen,

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 业务类型
      bizList: [],
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: '40px',
          fixed: 'left'
        },
        {
          title: '车号',
          dataIndex: 'vehicleNo',
          width: '110px'
        },
        {
          title: '车辆注册日期',
          dataIndex: 'registTime',
          width: '240px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd')
          }
        },
        {
          title: '行驶证有效期',
          dataIndex: 'drivingIndate',
          width: '240px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd')
          }
        },
        {
          title: '运输证有效期',
          dataIndex: 'transportIndate',
          width: '240px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd')
          }
        },
        /* {
            title: '驾驶员',
            dataIndex: 'driverId'
          },*/
        {
          title: '驾驶员姓名',
          dataIndex: 'driverName',
          width: '150px'
        },
        {
          title: '皮重',
          dataIndex: 'tare',
          width: '150px'
        },
        {
          title: '荷载重量',
          dataIndex: 'loads',
          width: '150px',
        },
        {
          title: '创建人',
          dataIndex: 'createId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
         {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
         {
          title: '更新人',
          dataIndex: 'updateId',
          width: '120px',
          customRender:(text, row, index) => {
             if (!text) return "";
             if (text === -1) return "manager";
             let userList= this.$store.getters.userList;
             return userList[text];
         }
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '200px',
          customRender: text => {
            const date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '130px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      // 所属菜单下拉
      corpSupplierSelect: null,

      corpLogisticsSelect: null,

      corpCompanySelect: null,

      corpBusinessSelect: null,

      driverSelect: null,

      typeSelect: null,

      corpVehicleTypeSelect :null,

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return vehiclePage(Object.assign(parameter, this.queryParam)).then(res => {
          setTimeout(() => {
            $('.blacktr').parents('tr').css("background-color", "#ddd")
          }, 1000);
          return res.data
        })
      },
      selectedRowKeys: [],
      selectedRows: [],
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelect()
    this.bizList = this.$store.getters.bizList
  },
  mounted () {

  },
  methods: {

    querySelectDriverInfo(vehicleNo,phone,driverName){
      new Promise(resolve => {
        const data = queryDriverInfo({vehicleNo: vehicleNo,phone:phone,driverName:driverName}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        if(res.length>0){
            if(driverName){
                this.phoneSelect=[]
               for(var i=0;i<res.length; i++){
                 const newData = this.phoneSelect.filter(item => item == res[i].phone)
                 if(newData.length==0) {
                   this.phoneSelect.push(res[i].phone)
                 }
               }
               if(this.phoneSelect.length>0){
                 this.mdl.phone=this.phoneSelect[0]
                 this.changePhone(this.mdl.phone)
               }
            }else{
              this.mdl.driverId=res[0].id
            }
        }
      })

    },
    changePhone(value){
     this.mdl.phone=value
      if(value && value.length>4){
        this.querySelectDriverInfo('',value,'')
      }
    },
    changeVehicleNo(e){

       var vehicleNo= e.target.value
      if(vehicleNo && vehicleNo.length>4){
        this.querySelectDriverInfo(vehicleNo,'','')
      }

    },

    changeDriverNameParam(e){

      var driverNameParam= e.target.value
      if(driverNameParam){
        this.querySelectDriverInfo('','',driverNameParam)
      }

    },

    changeVehicleType(e) {
     // this.$refs.vehicleTypeClients.onFieldChange()
      const target = this.corpVehicleTypeSelect.filter(item => e == item.id)
       if(target.length>0){
        this.mdl.loads = target[0].loadWeight
       }
     // this.form.setFields({vehicleTypeId: {value: e}})
      this.mdl.vehicleTypeId=e
    },

    moment,
    // 手机号校验事件
    validatePhoneBlur(e) {
      const validatePhoneReg = /^1[3456789]\d{9}$/
      if (e.target.value && !validatePhoneReg.test(e.target.value)) {
        const arr = [
          {
            message: '您输入的手机格式不正确!',
            field: 'phone'
          }
        ]
        this.form.setFields({ phone: { value: e.target.value, errors: arr } })
      }
    },
    // 身份证号校验事件
    validateIdCardBlur(e) {
     // const validateIdCardReg = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      const validateIdCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      if (e.target.value && !validateIdCardReg.test(e.target.value)) {
        const arr = [
          {
            message: '您输入的身份证号格式不正确!',
            field: 'idcard'
          }
        ]
        this.form.setFields({ idcard: { value: e.target.value, errors: arr } })
      }
    },
    // 验证浮点数
    validateFloatBlur(e) {
      const validateFloatReg = /^[+-]?((0|([1-9]\d*))\.\d+)?$/
      if (e.target.value && !validateFloatReg.test(e.target.value)) {
        const arr = [
          {
            message: '请输入数字类型!',
            field: 'tare'
          }
        ]
        this.form.setFields({ tare: { value: e.target.value, errors: arr } })
      }
    },
    loadSelect() {
      // 从后台拉去下拉列表数据

      new Promise(resolve => {
        const data = vehicleTypeList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.corpVehicleTypeSelect = res
      })

      new Promise(resolve => {
        const data = getCorpSupplierList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.corpSupplierSelect = res
      })

      new Promise(resolve => {
        const data = corpLogisticsList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.corpLogisticsSelect = res
      })

      new Promise(resolve => {
        const data = corpCompanyList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.corpCompanySelect = res
      })

      new Promise(resolve => {
        const data = corpBusinessList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.corpBusinessSelect = res
      })

      new Promise(resolve => {
        const data = driverList({}).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.driverSelect = res
      })
      this.typeSelect = this.$store.getters.codeList.basic_black_list_type
    },

    filterOption(input, option) {
      // 用于下拉列表可搜索
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleEdit(record) {
      if(!record.used){
        record.used='1'
      }
      if (record.registTime) {
        record.registTime = moment(record.registTime)
      }
      if (record.drivingIndate) {
        record.drivingIndate = moment(record.drivingIndate)
      }
      if (record.transportIndate) {
        record.transportIndate = moment(record.transportIndate)
      }
      if(record.tareTime){
        record.tareTime = moment(record.tareTime)
      }
      this.mdl = Object.assign({}, record)
      //每次打开弹窗之前重置下form表单
      this.form = this.$form.createForm(this)
      // 弹出框显示
      this.visible = true
    },
    handleSave() {
      this.mdl = {}
      this.mdl.used='1'
      //每次打开弹窗之前重置下form表单
      this.form = this.$form.createForm(this)
      // 弹出框显示
      this.visible = true
    },

    handleOk() {
      if(this.mdl.maxAppoint && this.mdl.loads){
        if(this.mdl.maxAppoint >this.mdl.loads){
          const arr = [
            {
              message: '最大预约量不能超过荷载量!',
              field: 'maxAppoint'
            }
          ]
          this.form.setFields({ maxAppoint: {  errors: arr } })
          return
        }
      }
        if(this.mdl.minAppoint && this.mdl.maxAppoint){
            if(this.mdl.minAppoint >this.mdl.maxAppoint){
              const arr = [
                {
                  message: '您输入的最小预约量大于最大预约量!',
                  field: 'minAppoint'
                }
              ]
              this.form.setFields({ minAppoint: {  errors: arr } })
             return
            }
        }
      var  phone=this.mdl.phone
      const validatePhoneReg = /^1[3456789]\d{9}$/
      if (phone && !validatePhoneReg.test(phone)) {
        const arr = [
          {
            message: '您输入的手机格式不正确!',
            field: 'phone'
          }
        ]
        this.$message.warning('手机号格式错误', 3)
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          if (this.mdl.id !== undefined) {
            vehicleUpdate(Object.assign({}, this.mdl))
            .then(res => {
              if (res.code === '0') {
                this.$refs.table.refresh()
                this.visible = false
              }
            }).catch((e) => {
              console.log(e)
            }).finally(() => {
              this.confirmLoading = false
            })
          } else {
            vehicleSave(Object.assign({}, this.mdl))
            .then(res => {
              if (res.code === '0') {
                this.$refs.table.refresh()
                this.visible = false
              }
            }).catch((e) => {
              console.log(e)
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        }
      })
    },

    handleBlack(record) {
      this.black['type'] = '1'
      this.black['name'] = record.vehicleNo
      this.black['recordId'] = record.id
      this.black['remark'] = ''
      this.form = this.$form.createForm(this)
      this.blackModel = true
    },

    handleBlackOk({ commit }) {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          blackListSave(Object.assign({}, this.black)).then(res => {
            if (res.code === '0') {
              let blackList = this.$store.getters.blackList
              if (!blackList['1']) blackList['1'] = {}
              blackList['1'][this.black.recordId] = this.black
              this.$store.commit('SET_BLACK', blackList)
              this.$refs.table.refresh()
              this.blackModel = false
              // setTimeout(() => {
              //   $('.blacktr').parents('tr').css("border-left", "10px solid #000")
              // }, 1000);
            } else {
              this.$message.error(res.message)
            }
          }).catch((e) => {
            console.log(e)
          }).finally(() => {
            this.confirmLoading = false
          })
        }
      })
    },
    handleDel(record) {
      var nthis = this
      this.$confirm({
        title: '提示',
        content: '确定要删除吗?',
        onOk() {
          nthis.confirmLoading = true
          return vehicleDelete(Object.assign(record, nthis.queryParam))
          .then(res => {
              if (res.code === '0') {
                nthis.$refs.table.refresh()
              }
            }).catch((e) => {
              nthis.confirmLoading = false
              console.log(e)
            }).finally(() => {
              nthis.confirmLoading = false
            })
        },
        onCancel() {}
      })
    },
    handleChange(value) {
      console.log('选择参数>>>' + value)
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style lang="less" scoped>
.ant-advanced-search-form .ant-form-item {
  margin-bottom: 0px;
}

/*.ant-form-item-label label {
  color: #f5222d;
}*/

</style>